<template>
  <a
    :href="href"
    @click="handleClick"
    class="link-button"
    :class="{small: size === 'small', regular: size === 'regular', large: size === 'large'}"
  >
    <svg
      v-if="leftIcon"
      width="7"
      height="10"
      viewBox="0 0 7 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.84582 1.17917L5.66666 0L0.666656 5L5.66666 10L6.84582 8.82083L3.02499 5L6.84582 1.17917Z"
        fill="#1695A3"
      />
    </svg>
    {{ text }}
    <svg
      v-if="rightIcon"
      width="7"
      height="10"
      viewBox="0 0 7 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.33336 0L0.15419 1.17917L3.97502 5L0.15419 8.82083L1.33336 10L6.33336 5L1.33336 0Z"
        fill="#1695A3"
      />
    </svg>
  </a>
</template>
<script>
export default {
  name: "link-button",
  props: {
    size: {
      type: String,
      default: "small"
    },
    text: String,
    href: String,
    leftIcon: Boolean,
    rightIcon: Boolean
  },
  methods: {
    handleClick() {
      this.$emit('click');
    }
  }
};
</script>
<style lang="scss" scoped>
.link-button {
  color: #1695a3;
  font-weight: 500;
  line-height: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 32px !important;
  cursor: pointer;
  svg:first-child {
    margin-right: 10px;
  }
  svg:last-child {
    margin-left: 10px;
  }
  &.small {
    font-size: 14px;
    svg {
      width: 14px;
      height: 14px;
      &:first-child {
        margin-right: 4px;
      }
      &:last-child {
        margin-left: 4px;
      }
    }
  }
  &.regular {
    font-size: 16px;
    svg {
      width: 24px;
      height: 24px;
    }
  }
  &.large {
    font-size: 20px;
    svg {
      width: 32px;
      height: 32px;
    }
  }
}
</style>